'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _de_DE = require('../../date-picker/locale/de_DE');

var _de_DE2 = _interopRequireDefault(_de_DE);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _de_DE2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/locale/de_DE.tsx
 ** module id = 703
 ** module chunks = 1
 **/